import { captureException, withScope, type Scope } from '@sentry/core';

/**
 * Logs an error to the browser console and to Sentry.
 */
export function logError(message: string, exception: Error): void;
export function logError(exception: Error): void;
export function logError(...args: [string, Error] | [Error]): void {
  // eslint-disable-next-line no-console
  console.error(...args);
  captureException(args.length === 1 ? args[0] : args[1]);
}

/**
 * Logs a fatal error to the browser console and to Sentry.
 */
export function logFatalError(message: string, exception: Error): void;
export function logFatalError(exception: Error): void;
export function logFatalError(...args: [string, Error] | [Error]): void {
  // eslint-disable-next-line no-console
  console.error('Fatal Error: ', ...args);
  const err = args.length === 1 ? args[0] : args[1];

  withScope((scope: Scope) => {
    scope.setLevel('fatal');
    captureException(err);
  });
}

/**
 * Logs a warning to the browser console and to Sentry.
 */
export function logWarning(message: string, exception: Error): void;
export function logWarning(exception: Error): void;
export function logWarning(...args: [string, Error] | [Error]): void {
  // eslint-disable-next-line no-console
  console.warn(...args);
  const err = args.length === 1 ? args[0] : args[1];

  withScope((scope: Scope) => {
    scope.setLevel('warning');
    captureException(err);
  });
}
